import Electrode from './Electrode';

export default Electrode;



/** WEBPACK FOOTER **
 ** ./source/101-electrode/index.js
 **/